/**
 * My cheeky name for an Increment/Decrement button pair.
 */
import { styled } from '@linaria/react';
import { Plus, Minus } from 'lucide-react';

import VisuallyHidden from '@/components/VisuallyHidden';

function InkDeck({
  value,
  highlighted,
  handleIncrement,
  handleDecrement,
}) {
  return (
    <Wrapper>
      <Button
        style={{
          '--background': highlighted
            ? 'var(--color-gray-500)'
            : 'var(--color-gray-300)',
        }}
        onClick={handleDecrement}
        disabled={value === 0}
      >
        <Minus size={20} strokeWidth={3} />
        <VisuallyHidden>Decrement</VisuallyHidden>
      </Button>
      <Button
        style={{
          '--background': highlighted
            ? 'var(--color-gray-500)'
            : 'var(--color-gray-300)',
        }}
        onClick={handleIncrement}
      >
        <Plus size={20} strokeWidth={3} />
        <VisuallyHidden>Increment</VisuallyHidden>
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 2px;
`;

const Button = styled.button`
  display: grid;
  place-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  background-color: var(--background);
  color: var(--color-text);
  cursor: pointer;

  &:not(:disabled):hover {
    background-color: hsl(50deg 100% 50% / 0.5);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  &:first-of-type {
    border-radius: 6px 2px 2px 6px;
  }
  &:last-of-type {
    border-radius: 2px 6px 6px 2px;
  }

  svg {
    display: block;
  }
`;

export default InkDeck;
